<template>
  <div class="row pt-4 mt-3">
    <div class="col-lg-3">
      <!-- <h2 class="h4">Fixed Fee Prices</h2> -->
      <h2 class="h4">Fixed Fee <br />Price Guides</h2>
    </div>
    <div class="col-lg-9">
      <!-- Loading -->
      <div v-if="isLoading" class="border rounded-3 p-5 text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!-- / Loading -->

      <!-- Loaded and no results -->
      <div v-if="!isLoading && pricesToShow.length == 0" class="border rounded-3 p-4 text-left">
        <div class="text-danger fw-bold">Nothing to see here!</div>
      </div>
      <!-- / Loaded and no results -->

      <!-- Loaded && has results -->
      <div v-if="!isLoading && pricesToShow.length" class="border rounded-3 p-3 fixed-fee-prices">
        <fixed-fee-price @reload="fetch"
         v-for="(price) in pricesToShow" :key="`price-${price.id}`" :my-firm="myFirm"
          :price="price"></fixed-fee-price>
      </div>
      <!-- / Loaded && has results -->

      <!-- Add button -->
      <div class="mt-3">
        <create-fixed-fee-button-and-modal @reload="fetch" :my-firm="myFirm"></create-fixed-fee-button-and-modal>
      </div>
      <!-- / Add button -->
    </div>
  </div>
</template>

<script>
import EditableField from "../../../components/Display/EditableField.vue";
import myFirmPrices from "../../../api/my-firm-prices";
import _ from 'lodash';
import FixedFeePrice from './Prices/FixedFeePrice.vue';
import CreateFixedFeeButtonAndModal from "./Prices/CreateFixedFeeButtonAndModal.vue";

export default {
  props: ['myFirm'],
  components: { EditableField, FixedFeePrice, CreateFixedFeeButtonAndModal },
  data() {
    return {
      isLoading: false,
      prices: []
    }
  },
  created() {
    this.fetch();
  },
  computed: {
    pricesToShow() {
      let filtered = _.filter(this.prices, (price) => {
        return price.price_type == 'fixed';
      });
      return _.orderBy(filtered, ['id'], ['asc']);
    }
  },
  methods: {
    fetch() {
      let vm = this;
      vm.isLoading = true;
      myFirmPrices.fetch().then((response) => {
        vm.prices = response.data;
        vm.isLoading = false;
      }).catch((error) => {
        vm.isLoading = false;
        console.log(error);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fixed-fee-prices {
  .fixed-fee-price:last-child {
    border-bottom: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
}
</style>